module.exports = __webpack_public_path__ + "img/2016.10.2c78e871.png";